<template>
  <div style="padding-bottom: 10px;">

    <div class="result"
         style="margin-top: 50px">
      <div class="title">新增日结项目</div>
      <el-form ref="importForm"
               :model="importForm"
               :inline="true"
               :rules="rules"
               label-width="auto"
               class="form"
               v-enterToNext="true">
        <el-form-item label="项目名称"
                      prop="projectName">
          <el-input v-model="importForm.projectName"
                    placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="预计人数"
                      prop="numberOfEstimate">
          <el-input v-model="importForm.numberOfEstimate"
                    placeholder="请输入预计人数"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="footer">
        <!-- <el-button size="small "
                   :loading="submitLoading"
                   @click="(mateVisible = false), resetForm">关 闭</el-button> -->
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="onSubmit('importForm', 3)">确 定</el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  //import引入组件才能使用
  components: {},
  props: {
    dialogTitle: null,
    visible: Boolean,
    bankInfoList: Array,
  },
  data () {
    let validateNum = (rule, value, callback) => {
      //使用正则表达式进行验证纯数字
      if (!/^[1-9]{1,}[\d]*$/.test(value)) {
        callback(new Error("预估人数不正确"));
      } else {
        callback();
      }
    };
    return {
      importForm: {},
      projectName: "",
      submitLoading: false,
      mateVisible: true,
      imgPath: "",
      headerList: {},
      headerId: '',
      rules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        numberOfEstimate: [
          { required: true, message: "请输入预估人数", trigger: "blur" },
          { validator: validateNum, trigger: ["blur"] },
        ],
      },
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {

  },
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted () {
    this.DefaultSalaryHeader();
  },
  // 方法集合
  methods: {
    resetForm () {
      this.importForm = {};
      this.$refs.importForm.clearValidate();
    },
    closeDialog () {
      this.$emit("close");
    },
    // 获取默认工资条
    DefaultSalaryHeader () {

      this.headerList = {};
      this.$api.salary.DefaultSalaryHeader().then((res) => {
        if (res.code == 0) {
          res.data.forEach((element, i) => {
            if (i < 26) {
              element.field = "cell" + String.fromCharCode(65 + i);
            } else {
              element.field = "cellA" + String.fromCharCode(97 + i - 26);
            }
            this.$set(this.headerList, element.field, element.name.trim());
            // this.headerList[element.field] = element.name.trim();
            this.headerId = element.salaryHeaderMainId;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit (formName, type) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        let sendData = {
          projectName: this.importForm.projectName,
          numberOfEstimate: this.importForm.numberOfEstimate,
          salaryHeaderMainId: this.headerId,
          salaryHeader: this.headerList,
        };
        this.$api.salary.SalaryAdd(sendData).then((res) => {
          if (res.code == 0) {
            this.mateVisible = false;
            this.$router.push({
              path: "/addDayTimesheet",
              query: {
                flag: "edit",
                id: res.data,
                type: type,
              },
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.result {
  width: 400px;
  height: 300px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 1px 6px 13px 0px #d0d0d0;

  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .footer {
    text-align: center;
  }
  .title {
    font-size: 18px;
    margin-bottom: 15px;
  }
}
</style>